import styled from "styled-components";
export const StyledViewWrapper = styled.div`
  padding-top: .3rem;
  padding-right: .9rem;
  float: left;
`;
export const StyledEditWrapper = styled.div`
  padding-top: .5rem;
  padding-right: .7rem;
  float: left;
`;
export const StyledDeleteWrapper = styled.div`
  padding-top: .3rem;
  float: left;
`;